/** The wrap-up screen's recap grid (`.tuiles`). */
import { t } from '../../../i18n/fr';

import type { SessionClosingSummary } from '../../../api/types';

export interface SummaryTilesProps {
  summary: SessionClosingSummary;
}

/** Format an average quality out of 5, French decimal comma, or a dash. */
function qualityLabel(average: number | null): string {
  if (average === null) {
    return t('session.summary.noQuality');
  }
  return `${average.toString().replace('.', ',')} ★`;
}

/**
 * Render the session's closing recap: doors recorded, binômes mobilised,
 * average quality, and — highlighted, since it is the number a volunteer
 * must not mistake for a bad session — doors released back to the stock.
 *
 * @param props - The frozen closing summary (`docs/API.md` §3).
 * @returns The tile grid element.
 */
export function SummaryTiles({ summary }: SummaryTilesProps) {
  return (
    <div className="tuiles">
      <div className="tuile">
        <div className="n">{summary.doors_recorded}</div>
        <div className="l">{t('session.summary.tileRecorded')}</div>
      </div>
      <div className="tuile">
        <div className="n">{summary.participants}</div>
        <div className="l">{t('session.summary.tileParticipants')}</div>
      </div>
      <div className="tuile">
        <div className="n">{qualityLabel(summary.average_quality)}</div>
        <div className="l">{t('session.summary.tileQuality')}</div>
      </div>
      <div className="tuile tuile--star">
        <div className="n">{summary.doors_released}</div>
        <div className="l">{t('session.summary.tileReleased')}</div>
      </div>
    </div>
  );
}
